var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotificationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 25,
    viewBox: "0 0 26 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.4637 17.3765C23.4637 15.9249 22.4279 14.7152 21.0595 14.4355V8.84823C21.0595 4.3951 17.4456 0.78125 13 0.78125C8.55447 0.78125 4.94057 4.3951 4.94057 8.84823V14.4355C3.57214 14.7152 2.53632 15.9249 2.53632 17.3765C2.53632 19.0247 3.8821 20.3704 5.53782 20.3704H20.4622C22.118 20.3704 23.4637 19.0247 23.4637 17.3765Z",
    fill: "#111F3E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13 24.2187C14.8146 24.2187 16.3796 23.0997 17.0298 21.5045H8.97028C9.62049 23.0997 11.1855 24.2187 13 24.2187Z",
    fill: "#111F3E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationIcon);
export default __webpack_public_path__ + "static/media/notificationIcon.b0c4ce82c4ba95f2d41cc88037ea4cf2.svg";
export { ForwardRef as ReactComponent };